export default __webpack_public_path__ + "static/ConnectedAndAutomatedVehiclePreparations-27b1f6e182103733f343c3c65a6d85fb.jpg";